import { Component } from '@angular/core';
import { BackButtonComponent } from '../back-button-component/back-button-component';

@Component({
  selector: 'app-about-component',
  imports: [BackButtonComponent],
  templateUrl: './about-component.html',
  styleUrl: './about-component.css',
})
export class AboutComponent {}
